<template>
    <li @click="$emit('loadConversation', conversation)">
        <avatar :image-url="conversation.participant.imageUrl" :image-alt="conversation.participant.name"
            :user-id="conversation.participant.id"></avatar>
        <div class="chat-info flex-grow-1">
            <h5 class="mb-0">{{ conversation.data.subject }} - {{ conversation.participant.name }}</h5>
            <p class="card-text text-truncate">
                {{ conversation.message.body }}
            </p>
        </div>
        <div class="chat-meta text-nowrap">
            <small class="float-end mb-25 chat-time">{{ conversation.message.time }}</small>
            <messages-counter :count="conversation.unread_count" :conversation="conversation"
                classes="bg-danger mt-2 float-end"></messages-counter>
        </div>
    </li>
</template>
<script>
import Avatar from "../avatars/Avatar.vue"
import MessagesCounter from "./Counter.vue"

export default {
    name: "Conversation",
    components: {
        Avatar,
        MessagesCounter
    },
    props: {
        conversation: {
            type: Object,
            reuired: true
        },
    },
    data() {
        return {
            status: 'avatar-status-offline'
        }
    }
}
</script>